import { useState } from "react";
import { TermsAndConditionsModal } from "@/components/common/TermsAndConditionsModal";
import { useAuth } from "@/contexts/AuthContext";
import { needsTermsAcceptance } from "@/lib/terms-and-conditions";

export function RequireTermsAcceptance() {
  const { user, acceptTerms, signOut } = useAuth();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!user || !needsTermsAcceptance(user)) {
    return null;
  }

  async function handleAcceptTerms() {
    setErrorMessage(null);
    setIsSubmitting(true);
    try {
      await acceptTerms();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Failed to save terms acceptance";
      setErrorMessage(message);
    } finally {
      setIsSubmitting(false);
    }
  }

  async function handleDeclineTerms() {
    setErrorMessage(null);
    await signOut();
  }

  return (
    <>
      <div className="fixed inset-0 z-40 bg-slate-950/80 backdrop-blur-sm" aria-hidden />
      {errorMessage ? (
        <div className="fixed bottom-6 left-1/2 z-[60] w-full max-w-md -translate-x-1/2 px-4">
          <p className="rounded-lg border border-red-500/30 bg-red-500/15 px-3 py-2 text-center text-sm text-red-300">
            {errorMessage}
          </p>
        </div>
      ) : null}
      <TermsAndConditionsModal
        isOpen
        onAccept={() => void handleAcceptTerms()}
        onDecline={() => void handleDeclineTerms()}
      />
      {isSubmitting ? (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/40">
          <p className="text-sm text-slate-200">Saving acceptance…</p>
        </div>
      ) : null}
    </>
  );
}
